export default class AuthHelper {
  static getToken() {
    return localStorage.getItem("token") || "";
  }

  static getRefreshToken() {
    return localStorage.getItem("refresh_token") || "";
  }

  static getRefreshTokenExpire() {
    return localStorage.getItem("refresh_token_expire") || "";
  }

  static getProfile() {
    try {
      const user = localStorage.getItem("user");
      return user ? JSON.parse(user) : {};
    } catch (error) {
      console.error("Error parsing user profile:", error);
      return {};
    }
  }

  static getPermissions() {
    return localStorage.getItem("permissions") || "";
  }

  static isLogged() {
    const token = AuthHelper.getToken();
    const refreshToken = AuthHelper.getRefreshToken();
    const profile = AuthHelper.getProfile();

    // Vérifie que le token existe ET que le profil n'est pas vide
    return !!token && !!refreshToken && Object.keys(profile).length > 0;
  }

  static saveUserInfo(data) {
    if (data?.token) {
      localStorage.setItem("token", data.token);
    }
    if (data?.refresh_token) {
      localStorage.setItem("refresh_token", data.refresh_token);
    }
    if (data?.refresh_token_expire) {
      localStorage.setItem("refresh_token_expire", data.refresh_token_expire);
    }
    if (data?.user) {
      localStorage.setItem("user", JSON.stringify(data.user));
    }
    if (data?.permissions) {
      localStorage.setItem("permissions", JSON.stringify(data.permissions));
    }
  }

  static logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("refresh_token_expire");
    localStorage.removeItem("user");
    localStorage.removeItem("permissions");
  }

  // Méthode utilitaire pour vérifier l'expiration du token
  static isTokenExpired() {
    const token = this.getToken();
    if (!token) return true;

    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      return payload.exp * 1000 < Date.now();
    } catch (error) {
      return true;
    }
  }

  // ============ NOUVELLE MÉTHODE ============
  /**
   * Vérifier si le refresh token est expiré
   * @returns {boolean} - true si expiré ou absent
   */
  static isRefreshTokenExpired() {
    const expireDate = this.getRefreshTokenExpire();

    // Si pas de date d'expiration, considérer comme expiré
    if (!expireDate) {
      console.log(" Pas de date d'expiration pour le refresh token");
      return true;
    }

    try {
      let expireTimestamp;

      // Si c'est un timestamp (nombre)
      if (!isNaN(expireDate)) {
        expireTimestamp = parseInt(expireDate);
      }
      // Si c'est une date string ISO
      else if (typeof expireDate === "string" && expireDate.includes("-")) {
        expireTimestamp = new Date(expireDate).getTime();
      }
      // Si c'est un nombre stocké comme string
      else {
        expireTimestamp = parseInt(expireDate);
      }

      // Vérifier si le timestamp est valide
      if (isNaN(expireTimestamp)) {
        console.log("Format de date invalide:", expireDate);
        return true;
      }

      const isExpired = expireTimestamp < Date.now();

      if (isExpired) {
        console.log(
          "Refresh token expiré le:",
          new Date(expireTimestamp).toLocaleString(),
        );
      } else {
        const daysLeft = Math.round(
          (expireTimestamp - Date.now()) / (1000 * 60 * 60 * 24),
        );
        console.log(`Refresh token valide - expire dans ${daysLeft} jours`);
      }

      return isExpired;
    } catch (error) {
      console.error(" Erreur vérification refresh token:", error);
      return true;
    }
  }

  /**
   * Récupérer le temps restant avant expiration du refresh token
   * @returns {Object|null} - { days, hours, minutes } ou null si pas de token
   */
  static getRefreshTokenTimeLeft() {
    const expireDate = this.getRefreshTokenExpire();
    if (!expireDate) return null;

    try {
      let expireTimestamp;

      if (!isNaN(expireDate)) {
        expireTimestamp = parseInt(expireDate);
      } else {
        expireTimestamp = new Date(expireDate).getTime();
      }

      const now = Date.now();
      const diffMs = expireTimestamp - now;

      if (diffMs <= 0) return null;

      return {
        days: Math.floor(diffMs / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60)),
        milliseconds: diffMs,
      };
    } catch (error) {
      console.error("Erreur calcul temps restant:", error);
      return null;
    }
  }
}
